import {
  animate,
  animateChild,
  group,
  query,
  style,
} from '@angular/animations';

export function slideToRight(duration: string, easing: string) {
  return [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transform: 'translateX(0%)',
      }),
    ]),
    query(':enter', [
      style({
        transform: 'translateX(-100%)',
      }),
    ]),
    query(':leave', animateChild()),
    group([
      query(
        ':leave',
        [
          animate(
            `${duration} ${easing}`,
            style({ transform: 'translateX(100%)' })
          ),
        ],
        { optional: true }
      ),
      query(
        ':enter',
        [
          animate(
            `${duration} ${easing}`,
            style({ transform: 'translateX(0%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ];
}

export function slideToLeft(duration: string, easing: string) {
  return [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transform: 'translateX(0%)',
      }),
    ]),
    query(':enter', [
      style({
        transform: 'translateX(100%)',
      }),
    ]),
    query(':leave', animateChild()),
    group([
      query(
        ':leave',
        [
          animate(
            `${duration} ${easing}`,
            style({ transform: 'translateX(-100%)' })
          ),
        ],
        { optional: true }
      ),
      query(
        ':enter',
        [
          animate(
            `${duration} ${easing}`,
            style({ transform: 'translateX(0%)' })
          ),
        ],
        { optional: true }
      ),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ];
}

export function fadeIn(duration: string, easing: string) {
  return [
    style({ opacity: 0 }),
    animate(`${duration} ${easing}`, style({ opacity: 1 })),
  ];
}

export function scaleIn(duration: string, easing: string) {
  return [
    style({
      opacity: 0,
      transform: 'scale(0)',
    }),
    animate(
      `${duration} ${easing}`,
      style({ opacity: 1, transform: 'scale(1)' })
    ),
  ];
}

export function fadeInUp(duration: string, easing: string) {
  return [
    style({
      opacity: 0,
      transform: 'translateY(32px)',
      offset: 0,
    }),
    animate(
      `${duration} ${easing}`,
      style({
        opacity: 1,
        transform: 'translateY(0)',
        offset: 1,
      })
    ),
  ];
}
